import { AccountMeta, OktaMetaData } from 'module/api/account/types';
import { LoginPolicyType } from 'module/api/company/types';

export const getEnabledIdp = (oktaMetaData?: OktaMetaData) => {
  return oktaMetaData?.idps?.find((idp) => idp.enabled);
};

export const useIsSamlMandatory = ({
  accountMeta,
}: {
  accountMeta?: AccountMeta;
}): boolean => {
  if (!accountMeta) {
    return false;
  }

  const isSamlEnabled = !!(accountMeta.okta.idps ?? []).filter(
    (idp) => idp.enabled,
  ).length;

  const isSamlMandated =
    accountMeta.company.authentications?.find(
      (auth) => auth.authType === LoginPolicyType.Idp,
    )?.mandatory || false;

  // if ssoEnabled is true and saml is mandated, return true
  return isSamlEnabled && isSamlMandated;
};
